import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Territory } from '../../../domain/Territory';
import { withLazyMounting } from '../../../components/hoc/LazyDialog';

interface Props {
    territory: Territory;
    isOpen: boolean;
    onClose: () => void;
}

const ShowTerritoryNotesDialog = ({ territory, isOpen, onClose }: Props) => {
    const { t } = useTranslation();

    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle>{t('notes')}</DialogTitle>
            <DialogContent>
                <Typography component="pre">
                    {territory.notes}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('close')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default withLazyMounting(ShowTerritoryNotesDialog);
